import { render, staticRenderFns } from "./DepositDetailFooter.vue?vue&type=template&id=2f8247fe&scoped=true&"
import script from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DepositDetailFooter.vue?vue&type=style&index=0&id=2f8247fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8247fe",
  null
  
)

export default component.exports